const category = {
  breadcrumb_home: '首页',
  breadcrumb_category: '分类',
  sort_latest: '最新更新',
  sort_popular: '最受欢迎',
  sort_rating: '评分最高',
  filter_all: '全部',
  sort_by: '排序',
  comic_chapters: '话',
  comic_views: '阅读',
  comic_rating: '分',
  no_results: '该分类下暂无漫画作品',
  load_more: '加载更多',
  result_count: '共 {{count}} 部作品',
};

export default category;